const CompanyAttributeCategoryEnum = {
  Financial: 'Financial',
  Hedging  : 'Hedging'
}

export default CompanyAttributeCategoryEnum
